import { type ChannelParamsMap } from '@anycable/core/channel'

// From @anycable/core
export function stringifyParams(params: ChannelParamsMap) {
  if (!params) return ''

  let parts = Object.keys(params)
    .sort()
    .map((k) => {
      let v = JSON.stringify(params[k])
      return `${JSON.stringify(k)}:${v}`
    })

  return `{${parts.join(',')}}`
}
